"use strict";
const { isQuoted, unQuotedString } = require('../../quotedSearchString');
const createSearchStringQuery = searchString => {
    if (!searchString) {
        return { or: [] };
    }
    const shouldPerformExactMatch = isQuoted(searchString);
    const unQuotedSearchString = unQuotedString(searchString);
    if (shouldPerformExactMatch) {
        return {
            or: [
                { GTIN: unQuotedSearchString },
                { articleNumber: unQuotedSearchString },
                { supplierArticleNumber: unQuotedSearchString },
                {
                    systembolagetArticleNumber: unQuotedSearchString,
                },
                {
                    metadata: {
                        fortnoxUrl: `https://api.fortnox.se/3/articles/${unQuotedSearchString}`,
                    },
                },
            ],
        };
    }
    return {
        or: [
            { name: { similar: unQuotedSearchString } },
            { shortName: { similar: unQuotedSearchString } },
            { productCategory: { similar: unQuotedSearchString } },
            { keywords: { similar: unQuotedSearchString } },
            { GTIN: unQuotedSearchString },
            {
                articleNumber: { iLike: `${unQuotedSearchString}%` },
            },
            {
                supplierArticleNumber: unQuotedSearchString,
            },
            {
                systembolagetArticleNumber: unQuotedSearchString,
            },
        ],
    };
};
module.exports = createSearchStringQuery;
